import { BlankState } from '@domain-group/suit-theme'

import activityImageUrl from '@assets/activity.svg'

const ActivityBlankState = () => (
  <BlankState boxProps={{ border: 'none' }} imageUrl={activityImageUrl}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>No Activity</BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>Activity will be logged here once work starts.</BlankState.Paragraph>
  </BlankState>
)

export default ActivityBlankState
